module.exports = __webpack_public_path__ + "img/tmp-patients-status-3.d7ae87ab.svg";